import { createAsyncAction } from 'react-redux-await-control';
import { backoffice } from '~/services';

// chat Consultar (CORE-2636 V2.2): sessão persistida no backend, vinculada ao ticket
export const getAssistantSession = createAsyncAction('GET_ASSISTANT_SESSION', {
  saveResult: true,
  initialValue: null,
  context: {
    request: ({ ticketId, userId }) =>
      backoffice.get(`/attendance/assistant/session`, { params: { ticketId, userId } }),
    responseParser: ({ data }) => data,
    onRequestError: () => {},
    errorParser: () => ({ sessionId: null, messages: [] }),
  },
});

export const sendAssistantMessage = createAsyncAction('SEND_ASSISTANT_MESSAGE', {
  saveResult: true,
  initialValue: null,
  context: {
    request: ({ ticketId, personId, userId, sessionId, message }) =>
      backoffice.post(`/attendance/assistant/chat`, { ticketId, personId, userId, sessionId, message }),
    responseParser: ({ data }) => data,
    onRequestError: () => {},
    errorParser: () => null,
  },
});
